/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */

import {set_previous_css, set_css_props} from './blackmostros.method.js';

// export default obj => {
//   return new Promise((resolve, reject) => {
//     resolve(BlackMostrosPathway(obj));
//     reject('bad');
//     });
//   };


let BlackMostrosPathway = (function(
  $
  // ~ _q // to remove
  ){
  /*
   * this object handles a pathway element
   *
   */
  var _pathid,
    _path,
    _props,
    _previous = {},
    _cssprops = {
      'top': 0,
      'z-index': 300,
      },
    displayed = false,
    mpublic = {};

  function _set_previous(props){
    set_previous_css(_previous, _path, _cssprops, props);
  }

  function _set_props(props){
    set_css_props(_path, props);
  }

  function _init(pathwayid, props){
    _pathid = pathwayid;
    _props = props;
    
    // set pathway    
    _path = $.getElementById(_pathid);
    // ~ _path = $(_pathid);

    // set previous values from dom
    _set_previous(props);
  }
  mpublic.init = _init;

  function _margin_top(size) {
    // set margin-top
  }
  mpublic.margin_top = _margin_top;

  function _get_height() {
    /*
     * calculate current header height
     * sum head + menu + pathway heights
     *
     */
    return _path.offsetHeight || 0;
    // ~ return _path.outerHeight(true) || 0;
  }
  mpublic.get_height = _get_height;

  function _fix(props) {
    /*
     * only need set top and z-index
     * but we need known header height
     *
     */
    _set_props(_props);
    if (props) {
      _set_props(props);
      }
  }
  mpublic.fix = _fix;

  function _unfix() {
    // only need set to previous props
    _set_props(_previous);
  }
  mpublic.unfix = _unfix;

  return mpublic;
});

export {
  BlackMostrosPathway,
  };
